import classNames from 'classnames';
import * as LogoIcons from '@/assets/graphics/logoIcons/logoIcons';
import Typography from '@/components/atoms/typography/typography';
import { usePageDetailsContext } from '@/libraries/contexts/page-details-context/page-details-context';
import { capitalizeFirstLetter } from '@/libraries/formatters/capitalize-first-letter';
import styles from './logo-feature-list.module.scss';

export interface LogoFeatureListProps {
  /** The class name to apply */
  className?: string;
  /** An array of the features to show */
  features: Content.Components['TripHighlightItemDto'][];
}

const LogoFeatureList = ({ className, features }: LogoFeatureListProps) => {
  const { brand } = usePageDetailsContext();

  const LogoIconComponent =
    LogoIcons[`${capitalizeFirstLetter(`${brand}`)}LogoIcon`];

  return (
    <div className={classNames(styles.component, className)}>
      {features.map((feature, featureIndex) => (
        <div
          key={featureIndex}
          className={classNames(styles.feature, className)}
        >
          <LogoIconComponent className={styles.icon} />

          <Typography className={styles.text} tagStyle="bodyMedium">
            {feature.description}
          </Typography>
        </div>
      ))}
    </div>
  );
};

LogoFeatureList.displayName = 'LogoFeatureList';

export default LogoFeatureList;
